// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"9b71bc1c","843":"d125fe74","977":"e5dd4407"}[chunkId] + ".chunk.js";
};